import { formatResponse, get, post, put, getApiEndpoint, getWebsiteEndpoint, transformApiUrl } from '../helpers/index.js';


class CustomerService {
  constructor(client) {
    this.client = client;
    this.apiEndpoint = getApiEndpoint()+'customer';
    this.apiEndpoint = transformApiUrl(this.apiEndpoint);
  }

  async all( salesPersonId = "", filterActive = "") {
    const action = 'read';
    const endpoint = `${this.apiEndpoint}/${action}`;
    const getResponse = await get(this.client, endpoint, {
      params: { id: '', email: '', salesPersonId,  filterActive },
    });
    return formatResponse(getResponse);
  }

  async allBasic() {
    const action = 'msread';
    const endpoint = `${this.apiEndpoint}/${action}`;
    const getResponse = await get(this.client, endpoint);
    return formatResponse(getResponse);
  }

  async create(data) {
    const action = 'create';
    const endpoint = `${this.apiEndpoint}/${action}`;
    const formattedData = {
      [action]: [data],
    };  
    const postResponse = await post(this.client, endpoint, formattedData);
    const [customerCreated] = formatResponse(postResponse);
    return customerCreated;
  }

  async findById(id) {
    const action = 'read';
    const endpoint = `${this.apiEndpoint}/${action}`;
    const getResponse = await get(this.client, endpoint, {
      params: { id, email: '', salesPersonId: '', filterActive : ''},
    }, true);
    const [customer] = formatResponse(getResponse);
    return customer;
  }

  async findByEmail(email) {
    const action = 'read';
    const endpoint = `${this.apiEndpoint}/${action}`;
    const getResponse = await get(this.client, endpoint, {
      params: { id: '', email, salesPersonId: '', filterActive : '' },
    });
    const [customer] = formatResponse(getResponse);
    return customer;
  }

  async update(id, data) {
    const action = 'update';
    const endpoint = `${this.apiEndpoint}/${action}`;
    const formattedData = {
      [action]: [data],
    };
    const putResponse = await put(this.client, endpoint, formattedData, {
      params: { id },
    });
    const [customerUpdated] = formatResponse(putResponse);
    return customerUpdated;
  }

  async updateBasic(id, data) {
    const getId = (maybeObjOrValue) => {
      if (maybeObjOrValue && typeof maybeObjOrValue === 'object' && 'value' in maybeObjOrValue) {
        return maybeObjOrValue.value; 
      }
      return maybeObjOrValue;
    };
  
    const isNumericId = (v) => v !== null && v !== undefined && /^\d+$/.test(String(v).trim());
  
    const currentData = {
      name         : data.name,
      email        : data.email,
      phone        : data.phone,
      rfc          : data.billingRfc,          
      customerType : data.customerType,         
      isInactive   : !!data.isInactive
    };
  
    if (data.potential !== undefined) {
      currentData.potential = Number(data.potential) || 0;
    }
  
    const territoryId = getId(data.territoryOption ?? data.territory);
    if (isNumericId(territoryId)) {
      currentData.territory = String(territoryId).trim();
    }
    if (data.lastVisitDate) {
      const s = String(data.lastVisitDate).trim();
      if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
        currentData.lastVisitDate = s;
      } else {
        const d0 = new Date(s);
        if (!isNaN(d0)) {
          const d = new Date(d0.getFullYear(), d0.getMonth(), d0.getDate());
          const yyyy = d.getFullYear();
          const mm = String(d.getMonth() + 1).padStart(2, '0');
          const dd = String(d.getDate()).padStart(2, '0');
          currentData.lastVisitDate = `${yyyy}-${mm}-${dd}`;
        }
      }
    }
      
    const priceListId = getId(data.priceListOption ?? data.pricesList);
    if (priceListId !== undefined && priceListId !== null && String(priceListId).trim() !== '') {
      currentData.pricesList = String(priceListId).trim();
    }
  
    Object.keys(currentData).forEach((k) => {
      if (currentData[k] === undefined || currentData[k] === null) {
        delete currentData[k];
      }
    });
  
    const action = 'updatebasic';
    const endpoint = `${this.apiEndpoint}/${action}`;
    const formattedData = { [action]: [currentData] };
  
    const putResponse = await put(this.client, endpoint, formattedData, { params: { id } });
    const [customerUpdated] = formatResponse(putResponse);
    return customerUpdated;
  }
    
  getWhatsappLink() 
  {
    return `${getWebsiteEndpoint()}ajax/orders/showOrder?id=`;
  }

  async getTypes( id = '' ) {
    const action = 'type';
    const endpoint = `${this.apiEndpoint}/${action}`;
    const getResponse = await get(this.client, endpoint, {
      params: { id },
    });
    return formatResponse(getResponse);
  }
}

export { CustomerService as default };
